@if (loading()) {
	<div class="risks__wrapper">
		<app-risk-skeleton id="risk-skeleton-1" />
		<app-risk-skeleton id="risk-skeleton-2" />
		<app-risk-skeleton id="risk-skeleton-3" />
		<app-risk-skeleton id="risk-skeleton-4" />
	</div>
} @else {
	@if (risks()) {
		<div class="risks__wrapper">
			@for (risk of risks(); track risk.id) {
				@if (risk.status === 'ACTIVE') {
					<app-risk [risk]="risk" (click)="onSelect(risk)" />
				}
			}
		</div>
	}
}
